import { CustomException, request, language } from '@tencent/ppd-base-libs';
import { to, getConfigWithLang } from '@tencent/wphk-base-utils';
/**
 * 获取跨境游无极配置
 * @returns
 */
export async function getWujiconfig(url: string) {
  const [error, wujiConfig] = await to(request.loadConfig(url));
  if (error || !wujiConfig) {
    new CustomException(error, 'GetWujiconfigErr', '加载无极配置失败');
    return [];
  }
  if (wujiConfig?.[0]?.travelLayout) {
    const formatWujiConfig =  wujiConfig?.[0]?.travelLayout.map(layoutItem => ({
      ...layoutItem,
      bannerlist: layoutItem?.bannerlist.map(item => ({
        ...item,
        ...getConfigWithLang({ imgUrl: JSON.parse(item.imgUrl) }, language.getLanguage()),
        ... getConfigWithLang({ jumpUrl: JSON.parse(item.jumpUrl) }, language.getLanguage()),
      })),
    }));
    wujiConfig[0].travelLayout = formatWujiConfig;
  }
  return wujiConfig;
}
